import { createClient } from "@supabase/supabase-js";

// Supabase Auth is the authoritative session layer (persisted + auto-refreshed by supabase-js). Publishable key only.
export const supabase = createClient(process.env.REACT_APP_SUPABASE_URL, process.env.REACT_APP_SUPABASE_ANON_KEY, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false, storageKey: "rio.auth" },
});

// The live access token is mirrored here so every existing consumer (api client, tick relay WS, AI panel) never uses a stale token.
export const mirrorToken = (session) => { if (session?.access_token) localStorage.setItem("felacoo_token", session.access_token); };
